const path = {
    outSourcedExport: '/outsourcedexport',
    directExport: '/directexport',
    consolidatedTipsExport: '/consolidatedtipsexport'
}

export { path }